import React, { ReactElement } from "react";
import { Loader, LoaderSizes, Button } from "@hid-galaxy-ui/galaxy-react";
import { useAppSelector } from "./redux";
import HIDCustomLogo from "./pages/auth/login/HIDCustomLogo";
import useLogoutHandler from "./hooks/useLogoutHandler";
import { useIsHidStaff } from "./hooks/useIsHidStaff";
import {
  useSessionPermissionsLoaded,
  useSessionPermissionsLoading,
} from "./hooks/useSessionPermissions";

/** Shell guard for /hid-admin and /hid-partner-admin. Without role_id, legacy HID_USER_ROLES fallback via useIsHidStaff. */
const AdminPortalProtectedRoute: React.FC<{ element: ReactElement }> = ({
  element,
}) => {
  const [triggerLogout] = useLogoutHandler();
  const roleId = useAppSelector((state) => state.auth.loggedUserDetail?.role_id);
  const loading = useSessionPermissionsLoading();
  const loaded = useSessionPermissionsLoaded();
  const isHidStaff = useIsHidStaff();

  if (roleId && loading && !loaded) {
    return (
      <div className="signing-in-container">
        <Loader variant={LoaderSizes.large} />
      </div>
    );
  }

  if (!isHidStaff) {
    return (
      <div className="signing-in-container">
        <div className="logo-wrapper">
          <HIDCustomLogo />
        </div>
        <div className="message-box">
          <p>Not Authorized</p>
          <Button
            variant="primary"
            label="Sign out"
            onClick={() => triggerLogout()}
          />
        </div>
      </div>
    );
  }

  return element;
};

export default AdminPortalProtectedRoute;
